import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/app/global-error.tsx");
